import { apiClient } from './api/client';
import { Document } from '../types';

// Standalone retry upload service. Issue #792: uses apiClient so the
// response interceptor mirrors wrapped envelope errors onto data.detail
// (string) and leaves data.error.details intact for the structured
// consumer in DocumentUpload. Also avoids the Issue #565 auth deadlock
// that the old raw-axios + supabase.auth.getSession() path triggered.
export class RetryUploadService {
  async retryDocumentUpload(
    projectId: string,
    file: File,
    originalFilename?: string,
    retryCount: number = 0,
  ): Promise<Document> {
    const formData = new FormData();
    formData.append('file', file);
    if (originalFilename) {
      formData.append('original_filename', originalFilename);
    }
    formData.append('retry_count', retryCount.toString());

    // apiClient interceptor attaches the auth token; we override the
    // timeout for large-file retries (default is 60s).
    const response = await apiClient.post<Document>(
      `/api/v1/projects/${projectId}/documents/retry`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300000, // 5 minutes for large files
      },
    );
    return response.data;
  }
}

export const retryUploadService = new RetryUploadService();
